function sharePage() {
    $('.share-page').dropDownMenu({
        disabled:    false,
        classBtn:    'button-1 button-1--small button-1--no-text button-1--variation-1',
        independent: false
    });
}
